import type {
  HamburgerMenuIcon,
  HamburgerMenuRowType,
} from './data/types/HamburgerMenuData';

// Icon event name and root of every row's `context`
export const hamburgerMenuTrackingName = 'Hamburger Menu';

// trackingName: English on every locale, never derived from the row title, so copy
// edits don't break Mixpanel history. Link rows reuse the desktop header's `Clicked: X` name
// TODO(@paprikka): review icon mapping (Business Solutions blue tint, illustration reuse) before merge, sc-68335
export const hamburgerMenuConstantsByRowType: Record<
  HamburgerMenuRowType,
  { icon: HamburgerMenuIcon; qaId: string; trackingName: string }
> = {
  // EXPLORE, top level
  'get-involved': {
    icon: { kind: 'icon', name: 'heart' },
    qaId: 'hamburger-menu-get-involved-link',
    trackingName: 'Idealist Days',
  },
  job: {
    icon: { kind: 'icon', name: 'briefcase' },
    qaId: 'hamburger-menu-job-link',
    trackingName: 'Find a Job',
  },
  volop: {
    icon: { kind: 'icon', name: 'hand' },
    qaId: 'hamburger-menu-volop-link',
    trackingName: 'Volunteer',
  },
  internship: {
    icon: { kind: 'icon', name: 'sign-path' },
    qaId: 'hamburger-menu-internship-link',
    trackingName: 'Internships',
  },
  org: {
    icon: { kind: 'icon', name: 'building' },
    qaId: 'hamburger-menu-org-link',
    trackingName: 'Organizations',
  },
  resources: {
    icon: { kind: 'icon', name: 'hammer' },
    qaId: 'hamburger-menu-resources-toggle',
    trackingName: 'Resources',
  },
  'business-solutions': {
    icon: { kind: 'icon', name: 'star-outline' },
    qaId: 'hamburger-menu-business-solutions-toggle',
    trackingName: 'Business Solutions',
  },

  // Resources children
  'career-advice': {
    icon: { kind: 'image', src: 'illustrations/article-illustration.svg' },
    qaId: 'hamburger-menu-career-advice-link',
    trackingName: 'Career Advice',
  },
  'volunteer-resources': {
    icon: { kind: 'image', src: 'illustrations/article-illustration.svg' },
    qaId: 'hamburger-menu-volunteer-resources-link',
    trackingName: 'Volunteer Resources',
  },
  'salary-explorer': {
    icon: { kind: 'image', src: 'illustrations/salary-illustration.svg' },
    qaId: 'hamburger-menu-salary-explorer-link',
    trackingName: 'Salary Explorer',
  },
  'recipes-for-action': {
    icon: { kind: 'image', src: 'illustrations/star-illustration.svg' },
    qaId: 'hamburger-menu-recipes-for-action-link',
    trackingName: 'Recipes For Action',
  },
  'employer-resources': {
    icon: { kind: 'image', src: 'illustrations/gear-illustration.svg' },
    qaId: 'hamburger-menu-employer-resources-link',
    trackingName: 'Employer Resources',
  },
  'volunteer-engagement-resources': {
    icon: { kind: 'image', src: 'illustrations/gear-illustration.svg' },
    qaId: 'hamburger-menu-volunteer-engagement-resources-link',
    trackingName: 'Volunteer Engagement Resources',
  },

  // Business Solutions children
  api: {
    icon: { kind: 'icon', name: 'cogs', colorName: 'brandBlue' },
    qaId: 'hamburger-menu-api-link',
    trackingName: 'API',
  },
  'search-module': {
    icon: { kind: 'icon', name: 'puzzle-piece', colorName: 'brandBlue' },
    qaId: 'hamburger-menu-search-module-link',
    trackingName: 'Search Module',
  },
  'volunteer-engagement-pages': {
    icon: { kind: 'icon', name: 'document', colorName: 'brandBlue' },
    qaId: 'hamburger-menu-volunteer-engagement-pages-link',
    trackingName: 'Volunteer Engagement Pages',
  },
  'csr-partners': {
    icon: { kind: 'icon', name: 'building', colorName: 'brandBlue' },
    qaId: 'hamburger-menu-csr-partners-link',
    trackingName: 'Partners',
  },

  // CREATE
  'post-a-listing': {
    icon: { kind: 'icon', name: 'pin' },
    qaId: 'hamburger-menu-post-a-listing-link',
    trackingName: 'Post a Listing',
  },
  'create-org': {
    icon: { kind: 'icon', name: 'plus' },
    qaId: 'hamburger-menu-create-org-link',
    trackingName: 'Add your Organization',
  },

  // ES/PT extras, no icon
  events: {
    icon: { kind: 'none' },
    qaId: 'hamburger-menu-events-link',
    trackingName: 'Browse events',
  },
  blog: {
    icon: { kind: 'none' },
    qaId: 'hamburger-menu-blog-link',
    trackingName: 'Blog',
  },
  'fundraising-resources': {
    icon: { kind: 'none' },
    qaId: 'hamburger-menu-fundraising-resources-link',
    trackingName: 'Fundraising Resource',
  },
  'post-an-event': {
    icon: { kind: 'none' },
    qaId: 'hamburger-menu-post-an-event-link',
    trackingName: 'Post an event',
  },
  'idealist-points': {
    icon: { kind: 'none' },
    qaId: 'hamburger-menu-idealist-points-link',
    trackingName: 'Idealist Points',
  },
  'help-center': {
    icon: { kind: 'none' },
    qaId: 'hamburger-menu-help-center-link',
    trackingName: 'Help Desk',
  },
};
